

export default () => {
    // const accountId = config.headers['X-TenancyAccount-Id'];
    // const agentId = config.headers['X-Agent-Id'];
    // const url = config.url.replace(config.baseURL, "");
    // const method = config.method;
    // const params = config.url.params;
    return null;
};